module.exports = ".demo-select label {\n  color: #f29931; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/demo-mode/demo-mode.component.scss
// module id = ./src/app/shared/components/demo-mode/demo-mode.component.scss
// module chunks = main